<template>
    <div  v-click-outside="onClickOutside">
        <el-input
                style="width: 282px"
                placeholder="请输入内容"
                v-model="searchContent"
                size="mini"
                @click.native="handleShow()">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <div class="card search-card"  v-if="showBox" >
            <div class="card-body">
                <el-tabs  v-model="activeName">
                    <el-tab-pane label="学生" name="students">
                        <div class="list">
                            <a v-for="student in students" :key="student.id">
                                <div class="content" @click="handleClickStudent(student.id,student.name)">
                                    <h5>{{student.name}}</h5>
                                    <template>
                                        <h6 v-if="student.educationalExperiences==null" class="card-subtitle">
                                            <span  class="desc">教育经历未填写</span>
                                        </h6>
                                        <h6 v-else  class="text-muted m-b-5">{{student.educationalExperiences.grade.name||'无信息'}} - {{student.educationalExperiences.school.name||'无信息'}}</h6>
                                    </template>
                                </div>
                                <div align="right" style="margin-bottom: 5px;margin-top: -30px;margin-right: 5px;">
                                    <el-button size="mini" type="text" @click="handleClickStudentReturnVisit(student.id,student.name)">回访详情</el-button>
                                </div>
                            </a>
                            <div class="text-center " style="margin-top: 20px">
                                <el-pagination
                                        small
                                        background
                                        @size-change="handleSizeChange"
                                        @current-change="handleCurrentChange"
                                        :current-page="currentPage"
                                        :page-size="5"
                                        :pager-count="5"
                                        layout="prev, pager, next"
                                        :total="total">
                                </el-pagination>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script>
    import * as vClickOutside from 'v-click-outside-x'
    export default {
        name: "Index",
        directives: {
            clickOutside: vClickOutside.directive
        },
        data(){
            return{
                path:'/search',
                activeName:'students',
                searchContent:'',
                showBox:false,
                students:{},
                total:0,
                currentPage: 1,
                currentPageSize:5
            }
        },
        watch:{
            activeName:function () {
                this.handleSearch()
            },
            searchContent:function () {
                this.handleSearch()
            }
        },
        created() {
            this.$wApi.addListen(this.path, this.handleData);
        },
        methods:{
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'list':
                        this.students =  data.students
                        this.total=data.total
                        break;
                }
            },
            handleSizeChange(val) {
                this.currentPageSize=val;
                this.handleSearch(this.currentPage,this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage=val;
                this.handleSearch(this.currentPage,this.currentPageSize)
            },
            onClickOutside(event){
                this.showBox=false
            },
            handleShow(){
                this.showBox=true
            },
            handleClickStudent(student_id,title){
                this.$store.dispatch('addView', {
                    'title': title,
                    'path': '/student/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/student/' + student_id})
                this.showBox=false
            },
            handleClickStudentReturnVisit(student_id, name){
                this.$store.dispatch('addView', {
                    'title': '回访' + name,
                    'path': '/returnVisitDetail/' + student_id,
                    'closable': true
                });
                this.router.push({path: '/returnVisitDetail/' + student_id})
                this.onClickOutside();
            },
            handleSearch(currentPage=1,currentPageSize=5){
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'type': this.activeName,
                    'search': this.searchContent,
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .search-box{
        width: 250px;
        z-index: 99;
    }
    .search-card{
        /*display: none;*/
        position: fixed;
        top: 42px;
        left: 85px;
        width: 300px;
        height: 600px;
    }
    .list{
        display: flex;
        flex-direction: column;
        max-height: 500px;
        overflow-y: auto;
        a{
            &:hover{
                cursor: pointer;
                opacity: 0.8;
            }
            margin: 5px 0;
        }

        .content{
            h5, h6{
                margin: 15px 20px;
            }
            flex: 1;
            border: 1px solid #ddd;
        }
    }
</style>
